// @flow

import React from 'react';
import type {IconAsset} from 'sail/Icon/types';

type IconProps = {
  color?: string,
  size?: number,
};

function MiniPlayerSVG(props) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 15.8846H2.5C1.11929 15.8846 0 14.7137 0 13.2692V4.11538C0 2.67095 1.11929 1.5 2.5 1.5H15C16.3807 1.5 17.5 2.67095 17.5 4.11538V8.03846H18.75C19.4404 8.03846 20 8.62394 20 9.34615V17.1923C20 17.9145 19.4404 18.5 18.75 18.5H7.5C6.80964 18.5 6.25 17.9145 6.25 17.1923V15.8846ZM2.5 4.11538H15V8.03846H7.5C6.80964 8.03846 6.25 8.62394 6.25 9.34615V13.2692H2.5L2.5 4.11538Z"
      />
    </svg>
  );
}

export const MiniPlayerIcon: IconAsset = {
  colorable: true,
  name: 'MiniPlayer',
  category: 'icon',
  svg: (MiniPlayerSVG: any),
};

export const Expand = ({color = 'white', size = 20}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0047 20C15.4884 20 20 15.4884 20 10.0047C20 4.51156 15.4884 0 9.99528 0C4.50212 0 0 4.51156 0 10.0047C0 15.4884 4.51156 20 10.0047 20ZM5.78575 10.184C5.29495 10.184 4.89854 9.79707 4.89854 9.30628V6.08778C4.89854 5.3327 5.30439 4.92685 6.0689 4.92685H9.27796C9.75932 4.92685 10.1557 5.32327 10.1557 5.81406C10.1557 6.30486 9.75932 6.69184 9.27796 6.69184H8.89099L7.80557 6.54082L9.59887 8.20198C10.0142 8.57008 9.99528 9.22133 9.59887 9.61774C9.20245 10.0142 8.5512 10.033 8.17367 9.61774L6.51251 7.81501L6.66352 8.9193V9.30628C6.66352 9.79707 6.26711 10.184 5.78575 10.184ZM10.6843 15.0826C10.2029 15.0826 9.80651 14.6862 9.80651 14.1954C9.80651 13.7046 10.2029 13.3176 10.6843 13.3176H11.0618L12.1567 13.4686L10.3634 11.8169C9.94809 11.4394 9.96697 10.7881 10.3539 10.3917C10.7504 9.99528 11.411 9.9764 11.7791 10.3917L13.4403 12.2039L13.2987 11.0996V10.7032C13.2987 10.2124 13.6951 9.82539 14.1765 9.82539C14.6673 9.82539 15.0543 10.2124 15.0543 10.7032V13.9217C15.0543 14.6767 14.6484 15.0826 13.8933 15.0826H10.6843Z"
      fill={color}
    />
  </svg>
);
